/**
 * Mirrors `Card.js` share-chip visibility for layout-mode placeholder cards.
 * Only `dynamic` grid cards carry `card.data` shaped like `customCardData`.
 *
 * @param {object} card  Layout grid card `{ component, data?, … }`
 * @returns {boolean}
 */
export function shouldShowShareBadgeInLayoutPreview(card) {
	if (!card || card.component !== 'dynamic') return false;
	const customCardData = card.data;
	if (!customCardData?._id) return false;
	const isSharedWithMe = Boolean(customCardData.isShared);
	const isSharedWithEveryone = Boolean(
		customCardData.isUniversalAccess || customCardData.isUniversal
	);
	return isSharedWithMe || !isSharedWithEveryone;
}

function sharedByDisplayName(customCardData) {
	if (!customCardData) return null;
	return (
		customCardData.shareInfo?.sharedBy?.fullName ||
		customCardData.sharedBy?.fullName ||
		customCardData.sharedByName ||
		customCardData.ownerName ||
		customCardData.createdBy?.fullName ||
		null
	);
}

/**
 * Props for the interactive layout-mode share chip + popper (`LayoutPlaceholderCard`).
 * Returns `null` when the share affordance should not appear (same rule as `Card.js`).
 *
 * @param {object} card
 * @param {{ sharedUsersByTabId?: object }} [options]
 * @returns {{ isSharedWithMe: boolean, sharedByName: string|null, sharedUsers: string[] }|null}
 */
export function getLayoutPreviewSharePanelProps(card, options = {}) {
	if (!shouldShowShareBadgeInLayoutPreview(card)) return null;
	const { sharedUsersByTabId = {} } = options;
	const d = card.data;
	const id = d._id != null ? String(d._id) : '';
	const isSharedWithMe = Boolean(d.isShared);
	const sharedByName = sharedByDisplayName(d);
	const rawList = sharedUsersByTabId[id];
	const sharedUsers = Array.isArray(rawList) ? rawList : [];
	return { isSharedWithMe, sharedByName, sharedUsers };
}
